import { DriverWithTracking, IDriverTracking } from "../models/DriverTracking";

export default function getLatestPoint(driver: DriverWithTracking): IDriverTracking | undefined {
  const sortedTracking = driver.tracking.sort((a, b) => {
    return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
  });
  return sortedTracking[0];
}